import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Street from './street';
import StreetTwo from './street-two';
import City from './city';
import Zip from './zip';
import StateNextOld from './state-next-with-old-select';

const Row = styled.div`
  min-height: 56px;
  width: 100%;
`;

const SingleLineWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    justify-content: space-between;
    flex-direction: row;
  }
`;

const StateAndZipWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    display: contents;
  }
`;

const SingleLineWrapperRowLeft = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: 30rem;
    padding-right: 0.5rem;
  }
`;

const SingleLineWrapperRowMiddle = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.values.xs}px) {
    min-width: 5rem;
    padding-right: 0.5rem;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    flex-direction: row;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: 15rem;
    padding-right: 0.5rem;
  }
`;

const SingleLineWrapperRowRight = styled(Row)`
  @media (min-width: ${props => props.theme.breakpoints.values.xs}px) {
    min-width: 10rem;
    max-width: 20rem;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    flex-direction: row;
  }

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    width: 20rem;
    justify-content: unset;
    align-items: unset;
    position: unset;
    flex-direction: unset;
  }
`;

const ManualAddressEntry = props => {
  const {
    error,
    value,
    type,
    hideStreet2,
    onChange,
    onBlur,
    touched,
    isLoading
    // setFieldValue
  } = props;

  return (
    <div>
      <Row>
        <Street
          isDisabled={isLoading}
          data-cv-test={`${type}AddressStreetLineOne`}
          error={error[`${type}Street`]}
          value={value[`${type}Street`]}
          name={`${type}Street`}
          id={`${type}Street`}
          touched={touched[`${type}Street`]}
          onChange={onChange}
          onBlur={onBlur}
          type={type}
        />
      </Row>

      {!hideStreet2 && (
        <Row>
          <StreetTwo
            isDisabled={isLoading}
            data-cv-test={`${type}AddressStreetLineTwo`}
            error={error[`${type}Street2`]}
            value={value[`${type}Street2`]}
            name={`${type}Street2`}
            id={`${type}Street2`}
            touched={touched[`${type}Street2`]}
            onChange={onChange}
            onBlur={onBlur}
          />
        </Row>
      )}

      <SingleLineWrapper>
        <SingleLineWrapperRowLeft>
          <City
            isDisabled={isLoading}
            data-cv-test={`${type}AddressCity`}
            error={error[`${type}City`]}
            value={value[`${type}City`]}
            name={`${type}City`}
            id={`${type}City`}
            touched={touched[`${type}City`]}
            onChange={onChange}
            onBlur={onBlur}
          />
        </SingleLineWrapperRowLeft>

        <StateAndZipWrapper>
          <SingleLineWrapperRowMiddle>
            <StateNextOld
              disabled={isLoading}
              onChange={onChange}
              onBlur={onBlur}
              touched={touched[`${type}State`]}
              data-cv-test={`${type}AddressState`}
              error={error[`${type}State`]}
              value={value[`${type}State`] || 'default'}
              name={`${type}State`}
            />
          </SingleLineWrapperRowMiddle>

          <SingleLineWrapperRowRight>
            <Zip
              isDisabled={isLoading}
              data-cv-test={`${type}AddressZip`}
              error={error[`${type}Zip`]}
              value={value[`${type}Zip`]}
              name={`${type}Zip`}
              id={`${type}Zip`}
              touched={touched[`${type}Zip`]}
              onChange={onChange}
              onBlur={onBlur}
            />
          </SingleLineWrapperRowRight>
        </StateAndZipWrapper>
      </SingleLineWrapper>
    </div>
  );
};

ManualAddressEntry.propTypes = {
  type: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.shape({})
  ]),
  hideStreet2: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  touched: PropTypes.shape({}),
  isLoading: PropTypes.bool
  // setFieldValue: PropTypes.func.isRequired
};

ManualAddressEntry.defaultProps = {
  type: 'home',
  error: false,
  value: null,
  hideStreet2: false,
  touched: {},
  isLoading: false
};

export default ManualAddressEntry;
